module.exports = __webpack_public_path__ + "img/canbadge-round-76mm-glitter_trimmark.cb49c9c2.png";